import '../../assets/styles/components/loaders.scss';

import ErrorBoundary from '@shared/components/ErrorBoundaries/ErrorBoundary';
import MinimizedHeader from '@shared/components/Layout/components/MinimizedHeader';
import LayoutContainer, { LayoutBodyType } from '@shared/components/Layout/LayoutContainer';
import SecureMsalRoute from '@shared/components/SecureMsalRoute/SecureMsalRoute';
import useAuthService from '@shared/hooks/useAuthService';
import importRemote from '@shared/utilities/federation/loadremote';
import React, { Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';
import legacyTheme from 'shared/theme/legacyCarmaxTheme';

import PageLoader from '../../components/PageLoading';

const CheckinRemote = React.lazy(() =>
    importRemote({
        remoteName: 'Checkin',
        scope: 'remote_checkin',
        module: 'Application',
        remoteUrlLocation: process.env.REMOTE_CHECKIN,
    })
);

const CheckinPage = () => {
    const { authService } = useAuthService();
    const [searchParams] = useSearchParams();
    return (
        <LayoutContainer
            includeFooter={false}
            layoutType={LayoutBodyType.Default}
            hideSubHeader={true}
            theme={legacyTheme}
            minimizedHeader={
                searchParams?.get('wv') ? <></> : <MinimizedHeader buttonLink={`/`} />
            }>
            <ErrorBoundary>
                <SecureMsalRoute>
                    <Suspense fallback={<PageLoader label="checkin-loading" />}>
                        <CheckinRemote authService={authService} />
                    </Suspense>
                </SecureMsalRoute>
            </ErrorBoundary>
        </LayoutContainer>
    );
};

export default CheckinPage;
